<template lang="pug">
	.step
		.step__title
			|Укажите данные для получения полиса
		.step__list
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/email.svg")
				.step__item-right
					app-input(:input="schema.mail", @handleInput="handleInput", :field.sync="mail")
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/phone.svg")
				.step__item-right
					app-input(:input="schema.phone", @handleInput="handleInput",:field.sync="phone")
			.step__item
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/monthly_calendar.svg")
				.step__item-right
					app-input(:input="schema.polisDate", @handleInput="handleInput",:field.sync="polisDate")
			.step__item
				.checkbox.checkbox_step4
					input.checkbox__control(type="checkbox", v-model="checkboxChecked", v-validate="{required: true}" @change="handleCheckboxChange" name="terms", id="checkbox-terms")
					label.checkbox__label(for="checkbox-terms")
						|Соглашаюсь с политикой обработки персональных данных и правилами страхования, подтверждаю , что не отношусь к категории ИПДЛ/РПДЛ, являюсь владельцем платежной карты, с которой производится оплата страховой премии.
		.step__desc
			|В страховку включены риски связанные с занятием любительским, профессиональным спортом или экстремальными видами спорта по всему миру.
		.step__button
			a.button.button_type-simple(href="#", @click.prevent="handleClickPrev")
				|Назад
		
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
export default {

  name: 'app-step2',
  components: {
    AppInput,
  },
  data() {
  	return {
  		checkboxChecked:true
  	}
  },
  methods:{
		handleInput(e){
			this.checkButton();
			// setTimeout(() => {
			// 	if(this.phone.length && this.mail.length && this.polisDate.length && this.checkboxChecked && !this.$validator.errors.items.length) {
   //        this.buttonIsDisabled = false;
			// 	} else {
			// 		this.buttonIsDisabled = true
			// 	}
			// },0)
			
		},
		checkButton(){
			let {phone, mail, polisDate, checkboxChecked} = this;
			
			setTimeout(() => {
				if(phone.length && mail.length && polisDate.length && checkboxChecked && !this.$validator.errors.items.length) {
          this.buttonIsDisabled = false;
          console.log('if')
				} else {
					console.log('else99')
					this.buttonIsDisabled = true
				}
			},0)
		},
		handleCheckboxChange(){
			this.checkButton();
			// setTimeout(() => {
			// 	if(this.phone.length && this.mail.length && this.polisDate.length && this.checkboxChecked && !this.$validator.errors.items.length) {
   //        this.buttonIsDisabled = false;
			// 	} else {
			// 		this.buttonIsDisabled = true
			// 	}
			// },0)
		},
		handleClickPrev(){
			this.$router.push({name:'step3'})
		}
  },
  computed:{
  	...mapFields([
      'phone',
      'mail',
      'polisDate',
      'buttonIsDisabled'
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  // popupIsActive: 'PopupIsActive'
		}),
		// checkButton(){
		// 	console.log(123)
		// 	if(this.phone.length && this.mail.length && this.polisDate.length){
		// 		this.buttonIsDisabled = false;
		// 		return true
		// 	}
		// }
  },
  watch: {
  	// phone(val) {
  	// 	console.log(val)
  	// }
  }
}
</script>

<style lang="scss">
	
	
</style>